// extracted by mini-css-extract-plugin
module.exports = {"animationCube":"AnimationCube_animationCube__V8LdN","cube":"AnimationCube_cube__Qp1Fw"};